import React from 'react';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import { IAppHeaderProps } from '../types/PropTypes';
import { AppState } from '../store/state/app.state';
import { withTranslation, WithTranslation } from 'react-i18next';
import CommonService from '../services/common/common-service';
import { toast } from 'react-toastify';
import { IAppHeaderState } from '../fleet-portal/types/stateTypes';
import { Common } from '../utils/constants';
import { Link } from 'react-router-dom';
import images from '../assets/images/index';
import { companyNameReplace } from '../utils';

class Header extends React.Component<IAppHeaderProps & WithTranslation, IAppHeaderState> {
    commonService: CommonService;

    constructor(props) {
        super(props);
        this.commonService = new CommonService();
        this.state = { helpPageURL: '' };
    }

    async componentDidMount() {
        const filterInput = {
            code: '',
        };
        filterInput.code = this.props.userData?.isOrganisation
            ? Common.ConfigurationKey.FLEET_PORTAL_U_GUIDE_URL
            : Common.ConfigurationKey.ADMIN_PORTAL_U_GUIDE_URL;
        await this.commonService
            .getConfiguration(filterInput)
            .then(async (res: any) => {
                let website = res.data[0].value;
                this.setState({
                    helpPageURL: website,
                });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            })
            .finally();
    }

    getUserName = (): string => {
        const { userData } = this.props;
        let name = '';
        if (userData && userData.firstName && userData.lastName) {
            name = `${userData.firstName} ${userData.lastName}`;
        }
        return name;
    };
    getOrganisationName = (): string => {
        const { userData } = this.props;
        if (userData && userData.organisation_name) {
            return `<div class="organisationName d-block text-truncate" style="max-width:140px" title="${userData.organisation_name}">${userData.organisation_name}</div>`;
        }
        return '';
    };
    toggle = () => document.body.classList.toggle('menu-open-mobile');

    myprofile = () => {
        this.props.history.push('/my-profile');
    };

    render() {
        const { t } = this.props;
        return (
            <header className="header">
                <div className="row align-items-center no-gutters">
                    <div className="col">
                        <button className="nav-icon" onClick={this.toggle}>
                            <span className="one"></span>
                            <span className="two"></span>
                            <span className="three"></span>
                        </button>
                        <a href="/" title={companyNameReplace(t('InstaVolt'))} className="logo">
                            <img src={images.adminLogoPNG} alt="" />
                        </a>
                    </div>

                    <div className="col-auto">
                        <ul className="header-right-bar">
                            <li>
                                <a
                                    href={this.state.helpPageURL}
                                    title={t('help')}
                                    className="icon-btn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={images.helpSVG} alt={t('help')} />
                                </a>
                            </li>
                            <li className="user-block">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        id="Profile-dropdown"
                                        className={_.isEmpty(this.getOrganisationName()) ? '' : 'pt-1'}
                                    >
                                        <img className="user-icon" src={images.avatarSVG} alt="" />
                                        <span
                                            className="name text-truncate"
                                            title={this.getUserName()}
                                            dangerouslySetInnerHTML={{
                                                __html: `${this.getUserName()} ${this.getOrganisationName()}`,
                                            }}
                                        ></span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={this.myprofile}>
                                            <img src={images.profileSVG} alt={t('navbar.myProfile')} />

                                            {t('navbar.myProfile')}
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            as={Link}
                                            to="/terms-and-conditions"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={images.icassignSVG} alt={t('navbar.termsConditions')} />
                                            {t('navbar.termsConditions')}
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={this.props.logout}>
                                            <img src={images.logoutSVG} alt={t('navbar.logOut')} />

                                            {t('navbar.logOut')}
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    userData: state.UserData,
});
export default connect(mapStateToProps, null)(withTranslation()(Header));
